module.exports = __webpack_public_path__ + "assets/img/jewelryBox.c6dc7128.png";